import React from 'react'

import { Box, Container } from '@material-ui/core'
import { Text } from '../'

const Certification = ({ trainningJourney }) => {
  return (
    <Container maxWidth="lg">
      <Box mb={4}>
        <Text color="primary" fontSize="7vh" variant="h1">
          Você concluiu o {trainningJourney?.name?.toLowerCase()}!
        </Text>
      </Box>
    </Container>
  )
}

export default Certification
